// console.log('Eric - Selluxe Dev');

const imageBannerSections = document.querySelectorAll('.selluxe-image-banner');

if (imageBannerSections.length > 0) {
  imageBannerSections.forEach(section => {
    const videoID = section.dataset.videoId;
    const playerID = section.dataset.playerId;
  
    if (videoID && playerID) {
      window.onYouTubeIframeAPIReady = function() {
        const player = new YT.Player(playerID, {
          height: '1920',
          width: '1080',
          videoId: videoID,
          playerVars: {
            "autoplay": 1,
            "controls": 0,
            "mute": 1,
            "playsinline": 1,
            "origin": 1,
            "iv_load_policy": 3,
            "rel": 0,
            "fs": 0, 
            "cc_load_policy": 0,
            "disablekb": 1,
            "loop": 1,
            "playlist": videoID
          }
        });
      };
  
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      } else if (window.YT && window.YT.Player) {
        onYouTubeIframeAPIReady();
      }
    }
  });
}

const testimonialV2 = document.querySelectorAll('.testimonials-v2');

if(testimonialV2.length > 0) {
  testimonialV2.forEach(testimonial => {
    const sliderContainer = testimonial.querySelector('.container.page-width');
    const id = sliderContainer.id;
    const slideOnMobile = sliderContainer.classList.contains('slide-on-mobile');
    let screenWidth = window.screen.width;

    if(sliderContainer.classList.contains('swiper')) {
      const options = {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          }
        }
      }
  
      const enableSlider = new Swiper(`#${id}`, options);
    }  
    
    if(screenWidth <= 767 && !slideOnMobile) {
      const divs = testimonial.querySelectorAll('div');
      
      if(divs.length > 0) {
        divs.forEach(div => {
          if(div.classList.contains('swiper') || div.classList.contains('swiper-wrapper') || div.classList.contains('swiper-slide')) {
            div.classList.remove('swiper');
            div.classList.remove('swiper-wrapper');
            div.classList.remove('swiper-slide');
          }
        });
      }
    }
  });
}
